import React from "react";
import {
  AutocompleteInput,
  FormDataConsumer,
  ReferenceInput,
} from "react-admin";
import { filterByName } from "../utils";

export class SpeakerSeriesInput extends React.PureComponent {
  render() {
    const {
      // Primary props
      allowEmpty = true,
      filterToQuery = filterByName,
      label = "Speaker Series",
      parentSource = "speaker",
      perPage = 100,
      reference = "series",
      sort = { field: "title", order: "ASC" },
      source = "series_id",
      // Other props
      ...rest
    } = this.props;
    function renderSpeakerSeriesInput(props) {
      const {
        // Primary props
        allowEmpty: _allowEmpty,
        filterToQuery: _filterToQuery,
        label: _label,
        parentSource: _parentSource,
        perPage: _perPage,
        reference: _reference,
        sort: _sort,
        source: _source,
        // Dependent props
        formData: { [parentSource]: speaker_id } = {},
        filter = { speaker_id },
        // Other props
        ...rest
      } = props;
      return (
        <ReferenceInput
          {...rest}
          // NOTE: Force a re-render when parent changes by setting `key`, so
          // that the correct set of sub-categories gets displayed on click.
          key={`${source}-series-of-${speaker_id}`}
          label={label}
          source={source}
          reference={reference}
          filter={filter}
          // filterToQuery={filterToQuery}
          perPage={perPage}
          sort={sort}
          allowEmpty={allowEmpty}
        >
          <AutocompleteInput filterToQuery={filterToQuery} optionText="title" />
        </ReferenceInput>
      );
    }
    return (
      <FormDataConsumer {...rest}>{renderSpeakerSeriesInput}</FormDataConsumer>
    );
  }
}
